import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
// Works with native <details> — do not toggle .open from a toggle handler (causes a loop).
export default class extends Controller {
  connect() {
    this.boundCloseOnOutside = this.closeOnOutsideClick.bind(this);
    this.boundCloseOnEscape = this.closeOnEscape.bind(this);
    this.onToggle = this.handleToggle.bind(this);
    this.element.addEventListener("toggle", this.onToggle);
  }

  disconnect() {
    this.removeListeners();
    this.element.removeEventListener("toggle", this.onToggle);
  }

  handleToggle() {
    if (this.element.open) {
      // Defer so the opening click does not immediately count as an outside click
      requestAnimationFrame(() => {
        document.addEventListener("click", this.boundCloseOnOutside);
        document.addEventListener("keydown", this.boundCloseOnEscape);
      });
    } else {
      this.removeListeners();
    }
  }

  close() {
    if (this.element.open) {
      this.element.open = false;
    }
    this.removeListeners();
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  removeListeners() {
    document.removeEventListener("click", this.boundCloseOnOutside);
    document.removeEventListener("keydown", this.boundCloseOnEscape);
  }
}
